import React from 'react';
import ActivePeriodFields from './ActivePeriodFields';
import EligibilityConditionsShared from './EligibilityConditionsShared';

const EligibilityConditionsBau = ({ formData, updateField }) => {
  return (
    <div className='eligibility-conditions-view'>
      <ActivePeriodFields formData={formData} updateField={updateField} />
      <EligibilityConditionsShared formData={formData} updateField={updateField} />
    </div>
  );
};

export default EligibilityConditionsBau;
